import styles from "./expenseGraph.module.css";
import PieIncomeChart from "./PieIncomeChart";
import { styled } from "@mui/material/styles";
import { Tooltip } from "@mui/material";
import { tooltipClasses } from "@mui/material/Tooltip";

const ListDonutWidget = ({ donutGraphData }) => {
  const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.black,
      fontSize: 13,
    },
  }));

  return (<>
    {donutGraphData?.totalExpense !== '0.00' && (<><div className={`${styles.ChartMainSec}`}>
      <div className={`${styles.TotalIncomeSec}`}>
        <p className={`${styles.Amount}`}>${donutGraphData?.totalExpense}</p>
        <p className={`${styles.Text}`}>Total Expenses</p>
        <p className={styles.Text2}>${(parseFloat(donutGraphData?.totalDue?.replace(/,/g, "") || 0) + parseFloat(donutGraphData?.totalPaid?.replace(/,/g, "") || 0)).toLocaleString(undefined, { minimumFractionDigits: 2 })}{" "}Current</p>

        <p className={`${styles.Text2}`}>
          ${donutGraphData?.totalUpcoming} Upcoming
        </p>
      </div>
      <div className={`${styles.ChartSec}`}>
        <PieIncomeChart categories={donutGraphData?.categories} />
      </div>
    </div>
    <div className={`${styles.ChartListCatMain}`}>
      {donutGraphData && donutGraphData?.categories?.map((c, i) => {
        const total = c?.total || 0;
        const paid = c?.paid || 0;
        const due = c?.due || 0;
        const upcoming = c?.upcoming || 0;
        const formatedTotal = parseFloat((c?.total || "0").replace(/,/g, ""));
        const formatedPaid = parseFloat((c?.paid || "0").replace(/,/g, ""));
        const formatedDue = parseFloat((c?.due || "0").replace(/,/g, ""));
        const formatedUpcoming = parseFloat((c?.upcoming || "0").replace(/,/g, ""));
        const completedPercent = total ? ((formatedPaid + formatedDue) / formatedTotal) * 100 : 0;
        const upcomingPercent = total ? (formatedUpcoming / formatedTotal) * 100 : 0;

        return (<div className={styles.ChartListCat} key={i}>
          <p>{c?.title} <span>${total.toLocaleString()}</span></p>
          <div className={styles.ChartProgressTrack}>
            <BootstrapTooltip
              title={
                <div className={styles.IncomeLineTooltip}>
                  <p>Paid: ${(parseFloat(paid?.replace(/,/g, "") || 0) + parseFloat(due?.replace(/,/g, "") || 0)).toLocaleString(undefined, { minimumFractionDigits: 2 })}</p>
                </div>
              }
            >
              <div style={{ width: `${completedPercent}%`, backgroundColor: c?.color, cursor: "pointer" }}></div>
            </BootstrapTooltip>
            <BootstrapTooltip
              title={
                <div className={styles.IncomeLineTooltip}>
                  <p>Upcoming: ${upcoming.toLocaleString()}</p>
                </div>
              }
            >
              <div style={{ width: `${upcomingPercent}%`, backgroundColor: c?.color, cursor: "pointer", filter: 'brightness(0.75)' }}></div>
            </BootstrapTooltip>
          </div>
        </div>);
      })}
      </div></>)}
    {donutGraphData?.totalExpense === '0.00' &&
      <div className={`${styles.NoDataMain}`}>
        <div className={`${styles.NoDataIMG}`}>
          <img src="/static/img/no-expense.png" alt="No Data" />
        </div>
        <p className={`${styles.NoDataText}`}>No spending yet</p>
        <p className={`${styles.NoDataTextSub}`}>Add your expenses to start tracking spending.</p>
      </div>
    }
  </>);
};

export default ListDonutWidget;